"use client";

import { ListCard } from "@/components/shared";
import { FollowersChange } from "@/components/shared";
import type { PublisherGameFollowers } from "../types";
import { RANK_LIST_CONFIGS } from "@/features/rank-list/shared";

interface PublisherGameFollowersCardsProps {
  games: PublisherGameFollowers[];
  onCardClick: (appid: number) => void;
}

export function PublisherGameFollowersCards({
  games,
  onCardClick,
}: PublisherGameFollowersCardsProps) {
  return (
    <div className="md:hidden">
      {games.map((game) => (
        <PublisherGameFollowersCard
          key={game.appid}
          game={game}
          onCardClick={onCardClick}
        />
      ))}
    </div>
  );
}

interface PublisherGameFollowersCardProps {
  game: PublisherGameFollowers;
  onCardClick: (appid: number) => void;
}

function PublisherGameFollowersCard({
  game,
  onCardClick,
}: PublisherGameFollowersCardProps) {
  const primaryColor = RANK_LIST_CONFIGS.followers.primaryColor;

  return (
    <ListCard
      item={game}
      onCardClick={onCardClick}
      renderImage={(item) => ({
        src: item.capsule_image,
        alt: item.name,
        width: 130,
        height: 49,
      })}
      renderTitle={(item) => item.name}
      renderPrice={() => ({ isFree: null, priceFinal: null })}
      renderPlatforms={() => ({
        supportsWindows: null,
        supportsMac: null,
        supportsLinux: null,
      })}
      renderImageFooter={(item) => (
        <div
          className="bg-[#1b2838] border border-[#2a475e] rounded px-2 py-1 text-center"
          style={{ color: primaryColor }}
        >
          <span className="text-[10px] opacity-70 block leading-tight">
            Followers
          </span>
          <span className="font-bold text-xs leading-tight block">
            {item.followers?.toLocaleString("en-US") ?? "—"}
          </span>
        </div>
      )}
      renderMetadata={(item) => (
        <>
          <span>ID: {item.appid}</span>
          {item.release_date && (
            <>
              <span className="text-[#2a475e] mx-1">•</span>
              <span>{item.coming_soon ? "Coming Soon" : item.release_date}</span>
            </>
          )}
        </>
      )}
      renderFooter={(item) => (
        <div className="flex items-center justify-between gap-4 mt-2 pt-2 border-t border-[#2a475e]">
          <div className="flex flex-col gap-1">
            <span className="text-xs text-[#8f98a0]">1D</span>
            <FollowersChange value={item.followers_1d} />
          </div>
          <div className="flex flex-col gap-1">
            <span className="text-xs text-[#8f98a0]">7D</span>
            <FollowersChange value={item.followers_7d} />
          </div>
          <div className="flex flex-col gap-1">
            <span className="text-xs text-[#8f98a0]">30D</span>
            <FollowersChange value={item.followers_30d} />
          </div>
        </div>
      )}
    />
  );
}

